// web/src/pages/Login.tsx — כניסה (D-245 · AC-10).
// 🆕 28.09 — AC-10: קישור כניסה במייל — "המכשול היחיד בין הלקוחה לתוכן ששילמה עליו".
// ✅ 28.09 — שרת דואר הוגדר ב-Supabase (no-reply@atida-s.com · mail.atida-s.com:465) ונבדק במייל אמיתי ⇒ LINK_FIRST = true:
//    הקישור הוא ברירת המחדל (כמו באפיון). ⚠️ לפני ההגדרה השולח המובנה שלח רק לצוות הפרויקט.
//    .b נשלח · .c קישור שפג (Supabase מחזיר #error_code=otp_expired) · .d לא הגיע (ספאם / שליחה חוזרת).
//    כניסה עם סיסמה נשארת כמסלול משני (צוות · משתמשות הבדיקה). ⏳ "המשיכי עם גוגל" — דורש הגדרת ספק ב-Supabase.
import { useEffect, useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthProvider";

const LINK_FIRST = true;

export function Login() {
  const { signIn, sendLink } = useAuth();
  const [mode, setMode] = useState<"link" | "password">(LINK_FIRST ? "link" : "password");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  // .c — חזרה מקישור שפג או שכבר נוצל
  useEffect(() => {
    const h = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const code = h.get("error_code") ?? h.get("error");
    if (code) {
      setError(code === "otp_expired" ? "הקישור פג תוקף או שכבר נוצל. אפשר לשלוח קישור חדש." : "הכניסה דרך הקישור לא הצליחה. אפשר לשלוח קישור חדש.");
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    if (mode === "link") {
      const err = await sendLink(email.trim());
      setBusy(false);
      if (err) setError(err); else setSent(true);
      return;
    }
    const err = await signIn(email.trim(), password);
    setBusy(false);
    if (err) setError(err);          // בהצלחה — AuthProvider מעביר לבד למסך הנכון
  }

  return (
    <main className="center-screen">
      <form className="card login" onSubmit={submit} noValidate>
        <h1>עתידה שמש</h1>
        <p className="muted">כניסה לאזור האישי</p>
        {error && <p className="notice notice-err" role="alert">{error}</p>}
        {sent ? (
          <>
            <p className="notice notice-ok" role="status">שלחנו קישור כניסה ל-<span dir="ltr">{email.trim()}</span>. בדקי את תיבת המייל.</p>
            <p className="muted small">לא הגיע? כדאי לבדוק בספאם, או <button type="button" className="linklike" onClick={() => setSent(false)}>לשלוח שוב</button>.</p>
          </>
        ) : (
          <>
            <div className="field">
              <label htmlFor="email">אימייל</label>
              <input id="email" type="email" dir="ltr" autoComplete="email" required
                     value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {mode === "password" && (
              <div className="field">
                <label htmlFor="password">סיסמה</label>
                <input id="password" type="password" dir="ltr" autoComplete="current-password" required
                       value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
            )}
            <button className="btn btn-primary" type="submit" disabled={busy || !email || (mode === "password" && !password)}>
              {busy ? (mode === "link" ? "שולחת…" : "מתחברת…") : mode === "link" ? "שלחו לי קישור כניסה" : "כניסה"}
            </button>
            <p className="muted small" style={{ marginTop: 12 }}>
              {mode === "link"
                ? <button type="button" className="linklike" onClick={() => { setMode("password"); setError(null); }}>כניסה עם סיסמה</button>
                : <button type="button" className="linklike" onClick={() => { setMode("link"); setError(null); }}>כניסה עם קישור במייל</button>}
            </p>
          </>
        )}
      </form>
    </main>
  );
}
